<template>
  <div
    class="warn-text p16 m16"
    v-if="!computedlist || computedlist.length < 1"
  >
    <i class="fa fa-exclamation-triangle r4" />No available <b></b
    >{{ type }} entries.
  </div>
  <div v-else>
    <!-- grid view -->
    <div
      v-if="view == 'grid'"
      class="flex ilist_grid_container wrap"
      :class="
        $store.state.windowWidth > 480 || $route.name === 'list' ? 'wrap' : ''
      "
      :id="'ilist_grid_container_' + (type.norm() || $route.params.type.norm())"
    >
      <div
        :id="'ilist_grid_link_' + item.id"
        :class="item.id + ' ilist_grid_link_container'"
        class="p8 flexx container"
        :key="itemIndex"
        v-for="(item, itemIndex) in computedlist"
      >
        <!-- <state :statedata="item" parent="griditem" list="true" /> -->
        <div
          class="flexy ilist_grid_item"
          v-if="
            !$store.state.search[type] ||
            $store.state.search[type].length < 1 ||
            JSON.stringify(item)
              .toLowerCase()
              .indexOf($store.state.search[type]) > -1
          "
        >
          <layout>
            <template #header>
              <div
                class="
                  ilist_grid_item_header
                  fill
                  flex
                  between
                  b4
                  border-bottom
                "
                :class="`ilist_grid_item_header_${item.id}`"
                v-if="
                  !$store.state.search[type] ||
                  $store.state.search[type].length < 1 ||
                  JSON.stringify(item)
                    .toLowerCase()
                    .indexOf($store.state.search[type]) > -1
                "
              >
                <span
                  class="
                    fill
                    between
                    flex
                    wrap
                    xs-font
                    align-center
                    justify-start
                    ilist_grid_item_content_meta
                  "
                  v-if="item.user"
                >
                  <user class :userid="item.user"></user>
                  <itime
                    v-if="item.created"
                    class="update-text"
                    :timestamp="item.events ? item.events.date : item.created"
                  ></itime>
                </span>
                <div
                  class="
                    flex
                    xs-font
                    horizontal-scroll
                    indicate-text
                    ilist_grid_item_content_tags
                  "
                  v-if="
                    item.basics &&
                    item.basics.tags &&
                    item.basics.tags.length > 0
                  "
                >
                  <b
                    class="xs-font flex ilist_grid_item_content_tag"
                    :key="tagKey"
                    v-for="(tag, tagKey) in item.basics.tags"
                  >
                    <router-link
                      class="
                        r8
                        flex
                        align-center
                        indicate-text
                        ilist_grid_item_content_tag_link
                      "
                      :to="`/tags/${item.type}/${tag}`"
                    >
                      <i
                        class="
                          fas
                          fa-hashtag fa-xs
                          ilist_grid_item_content_tags_tag_link_icon
                        "
                      ></i>
                      <span
                        class="ilist_grid_item_content_tags_tag_title"
                        :id="
                          'ilist_grid_item_content_tags_tag_title_' + tag.norm()
                        "
                        >{{ tag }}</span
                      >
                    </router-link>
                  </b>
                </div>
              </div>
              <b
                class="
                  flex
                  align-center
                  between
                  ilist_grid_item_content_title
                  fill
                  b8
                "
                v-if="item.basics"
              >
                <router-link
                  :to="'/i/' + type + '/' + item.id"
                  class="lg-font"
                  >{{ item.basics.title }}</router-link
                >
                <button
                  @click="$router.push('/i/' + type + '/' + item.id)"
                  :class="(item.purchases && 'success') || 'update'"
                  class="sm-font p4 flex align-center"
                >
                  <div
                    v-if="item.purchases"
                    class="lg-font r4 align-center flex"
                  >
                    <i class="sm-font fa-sm fas fa-dollar-sign"></i
                    ><b class="">{{ item.purchases.cost }}</b>
                  </div>
                  <div>
                    {{ (item.purchases && "Buy") || "Details" }}
                  </div>
                </button>
              </b>
            </template>
            <template #content>
              <div class="flex wrap" :class="`${item.type}-image`">
                <img
                  class="list_image"
                  :class="`${item.id}-listitem`"
                  :src="`${
                    item.basics && item.basics.image
                      ? item.basics.image
                      : $store.state.app.style.background
                  }`"
                  alt=""
                />
                <icontent
                  :content="item.basics.description.slice(0, 420)"
                  class="ilist_list_container_item_description"
                />
                <!-- <state
                  :parent="type"
                  :statedata="
                    Object.fromEntries(
                      Object.entries(item).filter((x) =>
                        [
                          'id',
                          'ownedBy',
                          'created',
                          'title',
                          'type',
                          'user',
                          'basics',
                        ].includes(x[0])
                      )
                    )
                  "
                  tree="true"
                /> -->
              </div>
            </template>
          </layout>
        </div>
      </div>
    </div>

    <!-- list view -->
    <div
      class="column ilist_list_container"
      v-else-if="list && view == 'list' && show.cheat === false"
    >
      <div
        :class="item.id"
        :key="itemIndex"
        v-for="(item, itemIndex) in computedlist"
        class="ilist_list_item border-bottom"
        :id="'ilist_list_container_' + item.id"
      >
        <span
          class="p8 flex ilist_list_subcontainer"
          v-if="
            !$store.state.search[type] ||
            $store.state.search[type].length < 1 ||
            JSON.stringify(item)
              .toLowerCase()
              .indexOf($store.state.search[type]) > -1
          "
        >
          <router-link
            v-if="item.basics && item.basics.image"
            :to="'/i/' + type + '/' + item.id"
            class="ilist_list_image_link"
          >
            <img
              class="ilist_list_image list_image"
              :class="`${item.id}-listitem`"
              :src="item.basics.image"
              :alt="item.basics.title"
            />
          </router-link>
          <div class="l8 ilist_list_content fill">
            <span
              class="
                b8
                flex
                wrap
                xs-font
                align-center
                between
                ilist_list_content_meta
              "
            >
              <itime
                v-if="item.created"
                class="update-text r8 ilist_list_content_meta_time"
                :timestamp="item.events ? item.events.date : item.created"
              ></itime>
              <span
                class="flex ilist_list_content_meta_tags r8"
                v-if="
                  item.basics && item.basics.tags && item.basics.tags.length > 0
                "
              >
                <router-link
                  class="
                    xs-font
                    r4
                    ilist_list_content_meta_tags_tag
                    indicate-text
                  "
                  :key="tagKey"
                  v-for="(tag, tagKey) in item.basics.tags"
                  style="white-space: nowrap"
                  :to="`/tags/${item.type}/${tag}`"
                >
                  <i class="fas fa-hashtag fa-xs"></i>
                  {{ tag }}
                </router-link>
              </span>
              <user
                class="ilist_list_content_meta_user"
                v-if="item.user"
                :userid="item.user"
              ></user>
            </span>
            <div class="flex between align-center">
              <router-link
                v-if="item.basics"
                :to="'/i/' + type + '/' + item.id"
                class="ilist_list_content_title lg-font"
                ><b>{{ item.basics.title }}</b></router-link
              >

              <button
                @click="$router.push('/i/' + type + '/' + item.id)"
                :class="(item.purchases && 'success') || 'update'"
                class="sm-font p4 flex align-center"
              >
                <div v-if="item.purchases" class="lg-font r4 align-center flex">
                  <i class="sm-font fa-sm fas fa-dollar-sign"></i
                  ><b class="">{{ item.purchases.cost }}</b>
                </div>
                <div>
                  {{ (item.purchases && "Buy") || "Details" }}
                </div>
              </button>
            </div>
            <icontent
              :content="item.basics.description.slice(0, 280)"
              class="ilist_list_container_item_description"
            />
            <!-- <state
                :parent="type"
                :statedata="
                  Object.fromEntries(
                    Object.entries(item).filter((x) =>
                      [
                        'id',
                        'ownedBy',
                        'created',
                        'title',
                        'type',
                        'user',
                        'basics',
                      ].includes(x[0])
                    )
                  )
                "
                list="true"
              /> -->
          </div>
        </span>
      </div>
    </div>

    <!-- post view -->
    <div
      class="flex ilist_post_container"
      v-else-if="list && view == 'post' && show.cheat === false"
    >
      <div class="ilist_post_container_posts">
        <div
          :id="item.id"
          :class="item.id"
          :key="itemIndex"
          v-for="(item, itemIndex) in computedlist"
          class="flex ilist_post_container_item container b16"
        >
          <div
            class="p8 flex align-center wrap flexy ilist_post_subcontainer_item"
            v-if="
              !$store.state.search[type] ||
              $store.state.search[type].length < 1 ||
              JSON.stringify(item)
                .toLowerCase()
                .indexOf($store.state.search[type]) > -1
            "
          >
            <span
              class="
                fill
                between
                flex
                wrap
                xs-font
                align-center
                b8
                ilist_post_container_item_meta
              "
              v-if="item.user"
            >
              <user
                class="r16 ilist_post_container_item_user"
                :userid="item.user"
              ></user>
              <div
                class="flex ilist_post_container_item_tags"
                v-if="
                  item.basics && item.basics.tags && item.basics.tags.length > 0
                "
              >
                <div
                  class="r4 ilist_post_container_item_tag_container"
                  :key="tagKey"
                  v-for="(tag, tagKey) in item.basics.tags"
                >
                  <router-link
                    class="indicate-text ilist_post_container_item_tag_link"
                    style="white-space: nowrap"
                    :to="`/tags/${item.type}/${tag}`"
                  >
                    <i
                      class="
                        fas
                        fa-hashtag fa-xs
                        ilist_post_container_item_tag_icon
                      "
                    ></i>
                    <span class="ilist_post_container_item_tag">{{ tag }}</span>
                  </router-link>
                </div>
              </div>
              <itime
                class="update-text ilist_post_container_item_time"
                :timestamp="item.events ? item.events.date : item.created"
              ></itime>
              <reputation
                :key="$store.state.counter + item.id"
                :fId="item.id"
                :fType="item.type"
                class="flex xs-font ilist_post_container_item_reputation"
              ></reputation>
            </span>

            <div class="flex between align-center fill b8">
              <router-link
                v-if="item.basics"
                class="
                  flex
                  between
                  align-center
                  ilist_post_container_item_title
                  xl-font
                "
                :to="'/i/' + type + '/' + item.id"
                ><b>{{ item.basics.title }}</b></router-link
              >
              <button
                @click="$router.push('/i/' + type + '/' + item.id)"
                :class="(item.purchases && 'success') || 'update'"
                class="sm-font p4 flex align-center"
              >
                <div class="lg-font r4 align-center flex">
                  <i class="sm-font fa-sm fas fa-dollar-sign"></i
                  ><b class="" v-if="item.purchases">{{
                    item.purchases.cost
                  }}</b>
                </div>
                <div>
                  {{ (item.purchases && "Buy") || "Details" }}
                </div>
              </button>
            </div>

            <img
              v-if="item.basics && item.basics.image"
              :src="item.basics.image"
              :alt="item.basics.title"
              style="width: 100%; object-fit: cover"
              class="b16 ilist_post_container_item_image"
              :class="`${item.id}-listitem`"
            />
            <div
              v-if="item.basics && item.basics.description"
              class="
                flex
                wrap
                flexw
                align-center
                ilist_post_container_item_content
              "
            >
              <p class="ilist_post_container_item_description">
                {{ item.basics.description.slice(0, 560) }}
              </p>
              <router-link
                v-if="item.basics.description.length > 560"
                class="update-text ilist_post_container_item_readmore"
                :to="'/i/' + type + '/' + item.id"
                >Read More</router-link
              >
            </div>
            <comments
              class="ilist_post_container_item_comments"
              :key="'comment' + $store.state.counter + item.id"
              :commentsid="item.id"
            ></comments>
          </div>
          <div class="flex wrap" v-if="!item.basics">
            <state
              :parent="type"
              :statedata="
                Object.fromEntries(
                  Object.entries(item).filter(
                    (x) =>
                      [
                        'id',
                        'ownedBy',
                        'created',
                        'title',
                        'type',
                        'user',
                        'basics',
                      ].indexOf(x[0]) === -1
                  )
                )
              "
              list="true"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue2Filters from "vue2-filters";

export default {
  name: "ilist",
  data() {
    return {
      allowed: {},
      list:
        (this.$store.state.items[this.type] &&
          Object.entries(this.$store.state.items[this.type]).map(
            (x) => x[1]
          )) ||
        [],
      show: {
        cheat: false,
        rep: false,
      },
      showError: false,
    };
  },
  computed: {
    computedlist() {
      if (!this.list || this.list.length === 0) return [];
      let list =
        this.limit && +this.limit > 1 && this.list.length > +this.limit
          ? this.list.slice(this.list.length - 1 - +this.limit, -1)
          : this.list;
      this.$_.orderBy(list, ["created"], this.sort == 1 ? 'desc' : 'asc');
      return (
        this.allowed &&
        this.allowed.map &&
        this.$_.orderBy(
          list.map((x) => {
            let item = JSON.parse(JSON.stringify(x));
            let allowedkeys = [];
            this.allowed.map((y) => {
              let key1 = y.split(".")[0],
                key2 = y.split(".")[1];
              allowedkeys.includes(key1)
                ? x[key1] && this.$set(item[key1], key2, x[key1][key2])
                : ((item[key1] = {}),
                  x[key1] && this.$set(item[key1], key2, x[key1][key2]));
              allowedkeys.push(key1);
            });
            return item;
          }),
          [this.order || "created"],
          [this.sort == 1 ? 'desc' : 'asc']
        )
      );
    },
  },
  mixins: [Vue2Filters.mixin],
  mounted: function () {
    let hook = this.$store.state.app.basics.items.filter(
      (x) => x.name === this.type
    )[0];
    hook &&
      hook.hooks &&
      hook.hooks.list &&
      hook.hooks.list.fun &&
      this.$store.dispatch("run", {
        from: "list " + this.type,
        if: hook.hooks.list.if || [],
        fun: hook.hooks.list.fun,
        payload: hook.hooks.list.payload || {},
      });
    this.list = [];
    var queryObj = {
      order: this.order || "created",
      limit: this.$route.name === "hello" ? 5 : 50,
      type: this.$route.name === "tags" ? "tags" : "list",
      collection: this.type || "list",
    };
    console.log(this.$route.params.tag);
    if (this.$route.params.tag) {
      queryObj.tag = this.$route.params.tag;
    }
    console.log({queryObj});
    return this.$store.dispatch("query", queryObj).then((ret) => {
      console.log({ret});
      let allowed = [];
      if (this.$store.state.app.forms[this.type]) {
        let model = JSON.parse(
          JSON.stringify(this.$store.state.app.forms[this.type])
        ).forms;
        model.map((x) => {
          x.inputs.map((y) => {
            y.display = typeof y.display !== "object" ? {} : y.display;
            y.display.list ? allowed.push(x.name + "." + y.label) : null;
          });
        });
      }
      this.allowed = allowed;

      if (this.$route.params.tag) {
        console.log({ret});
        setTimeout(() => {
          this.list = Object.entries(ret).map((x) => x[1]);
          this.$set(
            this.$store.state.tags[this.type],
            this.$route.params.tag,
            ret
          );
          this.show.cheat = true;
          this.show.cheat = false;
        }, 2000);
      } else {
        this.list = Object.entries(ret).map((x) => x[1]);
        this.$set(this.$store.state.items, this.type, ret);
        return this.list;
      }
    });
  },
  props: {
    order: { type: String, default: "created" },
    filter: { type: Object },
    limit: { type: [String, Number], default: "111" },
    type: { type: String },
    view: { type: String, default: "list" },
    description: { type: String },
    sort: { type: Number, default: 1 },
  },
  watch: {
    "$store.state.sorts": {
      handler: async function (val) {
        if (!this.$store.state.sorts[this.type]) return;
        let objval = JSON.parse(JSON.stringify(await val));
        this.list = !this.$store.state.filters[this.type] ? [] : this.list;
        if (objval[this.type]) {
          this.list = this.orderBy(
            this.$store.state.filters[this.type]
              ? this.list
              : this.$route.name === "tags"
              ? this.$store.state.tags[this.$route.params.type][
                  this.$route.params.tag
                ]
              : this.$store.state.items[this.type],
            objval[this.type][0],
            objval[this.type][1]
          ).map((x) => x.$value);
          return this.list;
        } else {
          return this.list;
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style>
.ilist_grid_link {
  flex: 1 1 33%;
  align-items: stretch;
  align-self: stretch;
  justify-content: space-between;
  max-width: 540px;
  max-height: 540px;
  overflow: auto;
  background-size: cover;
}
.ilist_grid_item_content_tags_tag_link {
  width: 100%;
  white-space: nowrap;
}
.ilist_list_image_link {
  width: 20%;
  min-width: 64px;
  min-height: 64px;
}

.ilist_list_image {
  object-fit: contain;
  width: 100%;
}
</style>
